import { GENRES, type Genre } from '@aeon-karaoke/cloud-convex/model/genres';
import { MonoLabel } from '@/component';
import { cn } from '@/lib/cn';

interface WelcomeGenresStepProps {
  selected: readonly Genre[];
  onChange: (selected: Genre[]) => void;
}

/** First run, step 2: pill chips, gold when selected, with a live count. */
export function WelcomeGenresStep({ selected, onChange }: WelcomeGenresStepProps) {
  const toggle = (genre: Genre) =>
    onChange(selected.includes(genre) ? selected.filter((g) => g !== genre) : [...selected, genre]);

  return (
    <div className="mt-11">
      <h1 className="text-[38px] font-semibold leading-[1.08] tracking-[-0.03em]">What do you sing?</h1>
      <p className="mt-3 max-w-[46ch] text-base leading-[1.5] text-mute">
        Pick a few and we will start your library with packs that fit. You can change this any time.
      </p>
      <div className="mt-[30px] flex flex-wrap gap-[10px]">
        {GENRES.map((genre) => {
          const on = selected.includes(genre);
          return (
            <button
              key={genre}
              type="button"
              aria-pressed={on}
              onClick={() => toggle(genre)}
              className={cn(
                'whitespace-nowrap rounded-full border px-4 py-[10px] text-sm font-medium',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accFill',
                on ? 'border-accFill bg-accFill text-accOn' : 'border-line2 bg-transparent text-ink hover:border-line2 hover:text-acc'
              )}
            >
              {genre}
            </button>
          );
        })}
      </div>
      <MonoLabel size="md" className="mt-[26px] block tracking-[0.12em]">
        {selected.length} selected
      </MonoLabel>
    </div>
  );
}
